import { DownOutlined, SettingOutlined, LoginOutlined } from '@ant-design/icons'
import { createFromIconfontCN } from '@ant-design/icons'
import { Layout, Menu, Popover } from 'antd'
import React, { useState } from 'react'
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom'
import { BreadcrumbName } from '@/components'

//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { set, toJS, runInAction } from 'mobx'


const LayoutPage = () => {
  //mobx
  const { LoginStore, InformationStore, DockingStore } = useStore()

  const { Header, Sider, Content, Footer } = Layout
  const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_3577584_bqm5eg68w3l.js',
  })

  const getItem = (label, key, icon, children) => {
    return {
      label, key, icon, children
    }
  }

  //路由高亮
  let { pathname } = useLocation()

  const [collapsed, setCollapsed] = useState(false)

  //退出按钮
  const navigate = useNavigate()

  const onLogout = () => {
    LoginStore.loginOut()
    navigate('/login')
  }
  const setaccount = () => {
    InformationStore.getReviseInformation(LoginStore.hzsid)
    InformationStore.getDropDownInformation()
    navigate('/setaccount')
  }
  //定义方法:菜单无限级递归
  const menuList = toJS(LoginStore.menuList)
  const topNavList = toJS(LoginStore.topNavList)
  let openKeys = ''
  const breadcrumbItems = []
  const daohangclick = (item) => {
    let path = item.path
    // console.log(222, path)
    if (path.indexOf("docking") !== -1) {
      DockingStore.getDataList()
      // if (DockingStore.data !== '') {
      //   window.open(DockingStore.data);
      //   // , "_blank", "noreferrer"
      // }
    }
  }

  const tree = (data, allData) => {
    return data.map((item) => {
      if (pathname === `/${item.path}`) {
        //按钮筛选
        runInAction(() => {
          set(LoginStore, { item: item })
        })
        //面包屑
        if (item.pid === 0) {
          breadcrumbItems.push({
            'id': item.id,
            'name': item.name
          })
        } else {
          const letMune = allData.filter(listItem => listItem.id === item.pid)
          breadcrumbItems.push({
            'id': letMune[0].id,
            'name': letMune[0].name,
          })
          breadcrumbItems.push({
            'id': item.id,
            'name': item.name
          })
        }
        openKeys = '' + item.pid
      }
      if (item.hasOwnProperty('children') === false) {
        return getItem(
          <Link to={item.path} onClick={() => daohangclick(item)}>
            {item.name}
          </Link>,
          `/${item.path}`,
          <IconFont type={item.icon || ' '} />,
          null
        )
      } else {
        return getItem(
          item.name,
          item.id,
          <IconFont type={item.icon || ' '} />,
          tree(item.children, allData)
        )
      }
    })
  }

  const treeMenu = (data, allData) => {
    return data.map((item) => {
      if (pathname === `/${item.path}`) {
        //按钮筛选
        runInAction(() => {
          set(LoginStore, { item: item })
        })
        //面包屑
        if (item.pid === 0) {
          breadcrumbItems.push({
            'id': item.id,
            'name': item.name
          })
        } else {
          const letMune = allData.filter(listItem => listItem.id === item.pid)
          breadcrumbItems.push({
            'id': letMune[0].id,
            'name': letMune[0].name,
          })
          breadcrumbItems.push({
            'id': item.id,
            'name': item.name
          })
        }
        openKeys = '' + item.pid
      }
      if (item.hasOwnProperty('children') === false) {
        return getItem(
          <Link to={item.path}>
            {item.name}
          </Link>,
          `/${item.path}`,
          <IconFont type={item.icon || ' '} />,
          null
        )
      } else {
        let flag = 1
        item.children.forEach((v) => {
          if (v.ismenu === 1) {
            flag = 2
          }
        })

        if (flag == 2) {
          return getItem(
            item.name,
            item.id,
            <IconFont type={item.icon || ' '} />,
            treeMenu(item.children, allData)
          )
        } else {

          return getItem(
            <Link to={item.path}>
              {item.name}
            </Link>,
            `/${item.path}`,
            <IconFont type={item.icon || ' '} />,
            null,
          )
        }
      }
    })
  }
  // console.log(menuList, 'menuList')
  const newList = treeMenu(menuList, menuList)
  // console.log(newList, 'newList')
  const newList02 = tree(topNavList, topNavList)
  // console.log(newList02, 'newList02')
  //退出
  const text = <span className='nameName'>{LoginStore.username}</span>
  const content = (
    <div className='leaveBtn'>
      {/* <p><span><SkinOutlined /></span>主题设置</p> */}
      {/* <p onClick={setaccount}><span><SettingOutlined /></span>账号设置</p> */}
      <p onClick={onLogout}><span><LoginOutlined /></span>退出系统</p>
    </div>
  )
  return (
    <Layout style={{
      minHeight: '100vh',
    }}>
      <Header
        className="hera">
        <div className="logo" style={{ color: '#ffffff', fontWeight: 'bold', fontSize: "16px" }}>
          玉米水肥一体化应用云服务
        </div>
        <Popover placement="bottomRight" name={text} content={content} trigger="click">
          <div className='userName'>{LoginStore.username} <span style={{ margin: '0 5px 0 5px' }}><DownOutlined /></span></div>
        </Popover>
      </Header>
      <Layout>
        <Sider width={260} collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} >
          <Menu theme="dark" selectedKeys={[pathname]} defaultSelectedKeys={[openKeys]} defaultOpenKeys={[openKeys]} mode="inline" items={newList} />
        </Sider>
        <Layout style={{
          padding: '24px 24px 0 24px',
        }}>
          <BreadcrumbName breadcrumbItems={breadcrumbItems}></BreadcrumbName>
          <Content
            style={{
              padding: 24,
              margin: 0,
              background: '#ffffff',
              overflow: " auto"
            }}
            className="site-layout-background"
          >
            {/* 出口 */}
            <Outlet />
          </Content>
          <Footer
            style={{
              textAlign: 'center',
              padding: '5px 50px 5px 50px',
              fontSize: '14px'
            }}
          >
            帮助    隐私及条款<br />
            cppyright©017 吉林省农业综合信息服务股份有限公司
          </Footer>
        </Layout>
      </Layout>

    </Layout>
  )
}

export default observer(LayoutPage)
